import { Actions } from '../../redux/Actions'
import { Dispatcher } from '../../redux/Dispatcher';
import { DrawingsCollection } from '../../drawings/DrawingsCollection';
import { Id_floor, } from '../../api/Identifiers'
import { Keys } from '../../redux/Datastore'
import { State, did_any_change, get_state } from '../../redux/State'
import { WorkordersCollection } from '../../workorders/WorkordersCollection';
import { Floor } from '../../Floor';

export function draw_floors_menu(): void {

    if (did_any_change(["menu_floorplans_expanded"])) {
        let menu_floorplans_expanded: boolean = get_state().get_boolean(Keys.MENU_FLOORPLANS_EXPANDED, true);
        if (menu_floorplans_expanded) {
            $("#menu_floorplans_header_chevron").attr("class", "glyphicon glyphicon-chevron-down")
            $("#menu_floorplans_content").show(400)
        }
        else {
            $("#menu_floorplans_header_chevron").attr("class", "glyphicon glyphicon-chevron-right")
            $("#menu_floorplans_content").hide(400)
        }
    }


    if (did_any_change([Keys.ID_BUILDING, Keys.ID_FLOOR, Keys.HASH_DATA_FLOORPLANS, Keys.HASH_BUILDINGS_DATA, Keys.DATA_WORKORDERS])) {
        let state: State = get_state();
        let workorders: WorkordersCollection = state.workorders;
        let drawings: DrawingsCollection = state.all_displayable_drawings.get_all_in_building(state.id_building);

        let menu_floorplans_content_list = $("#menu_floorplans_content_list")

        menu_floorplans_content_list.html("");  // remove all floorplans from the menu before building the menu.
        $("#menu_floorplans_content_list").html("");  // remove all assets from the menu before building the menu.
        
        drawings.floors.floors.forEach((floor:Floor)=>{
        
            let id_floor: Id_floor =floor.id;
            let label: string = floor.label;
            let menu_item_id: string = `floor_menu_item__${id_floor}`;
            let badge: string = ""
            let active_workorders_count: number = workorders.active_workorders.get_for_floor(id_floor).count;
            if (active_workorders_count > 0) {
                badge = active_workorders_count.toString();
            }

            let html: string = `<li style='padding: 2px' class='list-group-item'>
                <a href='#' id='${menu_item_id}' class='waves-effect'>
                ${label}
                </a><span class='badge' >${badge}</span>
                </li>`

            $(html).appendTo("#menu_floorplans_content_list");

            let anchor = $(`#${menu_item_id}`)
            let li = anchor.parent("li")
            anchor.click(function (menuItemAnchor_click) {
                menuItemAnchor_click.preventDefault();
                anchor = $(menuItemAnchor_click.currentTarget)
                let id_floor: string = anchor.data("id_location")
                Dispatcher.dispatch(Actions.ACTION_SET_FLOOR_ONLY, id_floor)
            })

            anchor.data("id_location", id_floor.value)
            anchor.data("id_floor", id_floor.value)
            li.data("id_location", id_floor.value)
            li.data("id_floor", id_floor.value)
        })
    }

    $("#menu_floorplans_content_list li").each(function (idx: any, li: any) {
        li = $(li)
        let id_location = li.data("id_location")
        if (id_location == get_state().id_floor) {
            li.addClass("selected")
        }
        else {
            li.removeClass("selected")
        }
    })
}




// WEBPACK FOOTER //
// ./src/ts/ui/menu/FloorsMenu.ts